import { CrudForm } from '../shared/CrudPage';
import { brandService } from '@kss/api';
import type { Brand, BrandCreate, BrandFilter } from '@kss/api';

type F = { name: string; description: string; logoUrl: string; isActive: boolean };
const empty: F = { name: '', description: '', logoUrl: '', isActive: true };

export default function NewBrand() {
  return (
    <CrudForm<Brand, BrandCreate, BrandFilter, F>
      title="brand"
      service={brandService}
      idKey="brandId"
      basePath="/panel/brands"
      emptyForm={empty}
      fields={[
        { key: 'name', label: 'Name', required: true, placeholder: 'SonicEdge' },
        { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Optional description', fullWidth: true },
        { key: 'logoUrl', label: 'Logo URL', type: 'url', placeholder: 'https://…/logo.png' },
        { key: 'isActive', label: 'Active', type: 'status' },
      ]}
      fromEntity={(r) => ({
        name: r.name ?? '',
        description: r.description ?? '',
        logoUrl: r.logoUrl ?? '',
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        brandId: id,
        name: f.name,
        description: f.description || undefined,
        logoUrl: f.logoUrl || undefined,
        isActive: f.isActive,
      })}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
